import MiscApi from "@/services/api/misc.js";
import { mapGetters } from "vuex";
import BrandApi from "@/services/api/brandApi.js";
import metaTags from "@/services/metaTags";
import sanitizeHtml from "sanitize-html";

const MiscApiService = new MiscApi(),
  BrandApiService = new BrandApi(),
  trimLimit = 400;

export default {
  props: {
    brand: Object,
    IsABrandUserOnTheirOwnBrandPage: Boolean,
    brandVanityUrlName: String,
    isRetailer: Boolean,
  },
  data() {
    return {
      metaDescription: null,
      descriptionExpanded: false,
      chatMe: null,
      chatOther: null,
      showChatButton: false,
      instagram_followers: null,
      trackingInfo: {
        "Brand name": this.brand.brand_name,
      },
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          vmid: "og:title",
          property: "og:title",
          content: `Bulletin: ${this.brand.brand_name}`,
        },
        {
          vmid: "og:image",
          property: "og:image",
          content: this.brand.brand_bio_image_url ? this.brand.brand_bio_image_url : undefined,
        },
        {
          vmid: "og:url",
          property: "og:url",
          content: `https://bulletin.co/brands/${this.brandVanityUrlName}`,
        },
        {
          vmid: "og:description",
          property: "og:description",
          content: this.brand.brand_description,
        },
      ],
    };
  },

  mounted() {
    if (this.user && this.user.role !== "ADMIN") {
      this.getUserInfoForChat();
    }
    this.setUpMetaTags();
  },
  destroyed() {
    this.restoreMetaTags();
  },

  computed: {
    brandBioTrimmed() {
      if (this.brand.brand_description && this.brand.brand_description.length > trimLimit) {
        return this.brand.brand_description.substring(0, trimLimit) + "...";
      }

      return this.brand.brand_description;
    },

    canBioExpand() {
      return this.brand.brand_description && this.brand.brand_description.length > trimLimit;
    },
    isRetailerApproved() {
      return this.$store.getters.isRetailerApproved;
    },
    ...mapGetters({
      user: "userState",
    }),
  },

  methods: {
    getUserInfoForChat,
    isChatButtonVisible,
    sanitizeText,
    setUpMetaTags,
    restoreMetaTags,
  },
};

async function getUserInfoForChat() {
  const { data } = this.user.brand_id ? await BrandApiService.getBrandMe() : await MiscApiService.getMeRetailer();

  this.chatMe = {
    fullName: `${data.first_name} from ${data.store_name ? data.store_name : data.brand_name}`,
    role: this.user.role,
    userId: this.user.brand_id ? this.user.brand_id : this.user.retailer_id,
    email: this.user.email,
  };

  this.chatOther = {
    storeName: this.brand.brand_name,
    firstName: this.brand.first_name,
    email: this.brand.email,
    userId: this.brand.id,
    role: "BRAND",
  };

  this.showChatButton = true;
}

function isChatButtonVisible() {
  const { thumbnail_image_url, id } = this.brand;

  if (!this.user) {
    return;
  }

  const { role, brand_id } = this.user;
  return this.showChatButton && thumbnail_image_url && this.user && role !== "ADMIN" && brand_id !== id;
}

function sanitizeText(text) {
  return sanitizeHtml(text, {
    allowedTags: ["b", "span", "em", "strong", "a", "u"],
    allowedAttributes: {
      a: ["href"],
    },
  });
}

function setUpMetaTags() {
  if (this.brand.brand_description) {
    this.metaDescription = metaTags.getDescription();
    metaTags.setBrandPageDescription(this.brand.brand_name, this.brand.brand_description);
    metaTags.setTitle(`${this.brand.brand_name} Wholesale & Retail on Bulletin.co`);
  }
}
function restoreMetaTags() {
  if (this.metaDescription) {
    metaTags.setBrandPageDescription(this.metaDescription);
    metaTags.setTitle(`Bulletin`);
  }
}
